import {useQuery} from '@tanstack/react-query'

import {cacheKeys} from 'api'
import useApi from 'hooks/api/useApi'

import useProfile from './useProfile'

export default function useNotificationsCount() {
  const api = useApi()
  const {profile} = useProfile()
  const {
    data: messagesCount,
    refetch: refetchCount,
    ...rest
  } = useQuery(
    [cacheKeys.notificationsUnreadCount],
    () => {
      // if (profile) return api.getUnreadNotificationsCount()
      return 0
    },
    {
      refetchInterval: 10000,
      refetchOnMount: false,
    },
  )

  return {
    messagesCount,
    refetchCount: () => refetchCount({force: true}),
    ...rest,
  }
}
